import React from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-multi-lang'
import configuration from '../../../utils/configuration'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { getSiteLogo, getSiteName } from '../../../utils/brandingConfig'
import FooterBootom from './FooterBottom'

import Badge from '@mui/material/Badge';
import HomeIcon from '../../../images/icons/home-new.svg?react'
import ChatIcon from '../../../images/icons/message-new.svg?react'
import LiveIcon from '../../../images/icons/live-new.svg?react'
import ResSearch from '../../../images/icons/search-new.svg?react'
import NotificationIcon from '../../../images/icons/notification-new.svg?react'
import Face2FaceIcon from '../../../images_new/icon/face2face.svg?react';
import VideoStoreIcon from '../../../images_new/icon/p_video.svg?react';
import '../../../main.css'

const Footer = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname

  const userId = localStorage.getItem('userId')
  const isVerifyPage = location.pathname === '/verify'

  function isActivePath(path) {
    return path === location.pathname
  }

  const Footer = (isLight) => {
    const homeNaavigate = !isVerifyPage ? '/home' : '/verify';
    const siteLogo = getSiteLogo({ isDark: !isLight });
    const siteName = getSiteName();
    return (
      <footer className={`footer_space ${isLight ? 'light' : 'dark'}`}>
        <div className="container">
          <section className="text-center pt-4 pb-4">
            <Link aria-label='navigate to home' onMouseDown={() => { navigate(homeNaavigate) }} to={homeNaavigate} >
              <img src={siteLogo} className="img-fluid" alt={siteName} />
            </Link>
          </section>
        </div>
        <FooterBootom />
      </footer>
    )
  }

  return (
    <>
      {location.pathname !== '/verify' && userId && (
        <div className="resp-sticky-footer">
          <ul className="nav_list_top d-flex w-100 justify-content-between sticky-footer-nav">
            <Link
              id="home-navigate"
              to='/'
              aria-label='navigate to home'
              className={`m-0 p-0 app-nav-item  ${isActivePath('/') ? 'm-current' : ''}`}
            >
              <HomeIcon className={`nav-icon-header ${isActivePath('/') ? 'nav-icon-selected' : ''}`} />
            </Link>
            <Link
              to={'/search'}
              id="search-navigate"
              aria-label='navigate to search'
              className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/search' ? 'm-current' : ''
                }`}
            >
              <ResSearch className={`nav-icon-header ${isActivePath('/search') ? 'nav-icon-selected' : ''}`} />
            </Link>
            <Link
              style={{ position: "relative" }}
              to={'/notification'}
              aria-label='navigate to notification'
              id="notification-navigate"
              className={`m-0 p-0 app-nav-item ${isActivePath('/notification') ? 'm-current' : ''}`}
            >
              <Badge badgeContent={props.bellCount} max={99} color="primary">
                <NotificationIcon
                  className={`nav-icon-header ${isActivePath('/notification') ? 'nav-icon-selected' : ''}`}
                />
              </Badge>
            </Link>
            <Link
              to={'/inbox'}
              id="message-navigate"
              aria-label='navigate to inbox'
              className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/inbox' ? 'm-current' : ''
                }`}
            >
              <ChatIcon className={`nav-icon-header ${isActivePath('/inbox') ? 'nav-icon-selected' : ''}`} />
            </Link>
            <Link
              id="live-navigate"
              to={'/live'}
              aria-label='navigate to live'
              className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/live' ? 'm-current' : ''
                }`}
            >
              <LiveIcon className={`nav-icon-header ${isActivePath('/live') ? 'nav-icon-selected' : ''}`} />
            </Link>
            <Link
              to={'/face2face'}
              aria-label='navigate to face2face'
              className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/face2face' ? 'm-current' : ''
                }`}
            >
              <Face2FaceIcon
                className={`nav-icon-header ${isActivePath('/face2face') ? 'nav-icon-selected' : ''
                  }`}
              />
            </Link>
            <Link
              to={'/video-store'}
              aria-label='navigate to video store'
              className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/video-store' ? 'm-current' : ''
                }`}
            >
              <VideoStoreIcon
                width={26}
                height={26}
                className={`nav-icon-header ${isActivePath('/video-store') ? 'nav-icon-selected' : ''
                  }`}
              />
            </Link>
          </ul>
        </div>
      )}
      {pathname === '/login' && Footer()}
      {(pathname === '/USC-2257' ||
        pathname === '/referral' ||
        pathname === '/how-it-works' ||
        pathname === '/contact-us' ||
        pathname === '/terms-of-Services' ||
        pathname === '/privacy-policy' ||
        pathname === '/about' ||
        pathname === '/support/billing') &&
        Footer('light')}
      {pathname.match('/reset-password') ? Footer() : null}
      {pathname.match('/register') ? Footer(false) : null}
      {pathname === '/face2face' ? Footer(false) : null}
    </>
  )
}

const mapStateToPros = (state) => ({
  bellCount: state.notification.bellCount
})

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

export default connect(mapStateToPros, mapDispatchToProps)(translate(Footer))
